module.exports = __webpack_public_path__ + "img/이동교통_old.7ed5ce9d.png";